<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          icon
          v-on="tooltip"
          @click="$emit('request-open')"
        >
          <v-icon color="indigo">
            mdi-folder-download
          </v-icon>
        </v-btn>
      </template>
      <span>Download Supporting Document</span>
    </v-tooltip>

    <v-dialog
      :value="open"
      max-width="800"
      persistent
    >
      <material-card
        :offset="10"
        :full-width="true"
        color="hrissecondary"
        title="Download Claim Supporting Documents"
        text="Please select how would you want it to be downloaded"
        class="mb-0"
        :loading="loading"
      > 
        <form v-if="open && !loading">
          <v-container>
            <v-row>
              <v-col cols="5">
                <v-row
                  no-gutters
                  class="py-0"
                >
                  <v-col>
                    <span> Merge all in one file? </span>
                    <v-radio-group
                      v-model="isMerged"
                      class="mt-0"
                      row
                    >
                      <v-radio
                        label="No"
                        :value="0"
                      />
                      <v-radio
                        label="Yes"
                        :value="1"
                      /> 
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row
                  no-gutters
                  class="py-0"
                >
                  <v-col>
                    <span> Group by? </span>
                    <v-radio-group
                      v-model="isGroupByClaimType"
                      class="mt-0"
                    >
                      <v-radio
                        label="Employee/Reference No."
                        :value="0"
                      />
                      <v-radio
                        label="Claim Type"
                        :value="1"
                      /> 
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="7"
                class="py-0"
              >
                <span> Included claim types: </span>
                <v-data-table
                  v-model="selectedClaimTypes"
                  v-validate="'required'"
                  :error-messages="errors.collect('selectedClaimTypes')"
                  data-vv-name="selectedClaimTypes"
                  data-vv-as="claim types"
                  :items="claimTypes"
                  :headers="headers"
                  show-select
                  hide-default-footer
                  disable-pagination
                  dense
                  item-value="id"
                />
                <v-divider class="ml-0 mr-0" />
                <span
                  v-if="selectedClaimTypes.length < 1"
                  class="red--text text--lighten-1 caption"
                >
                  {{ errors.first('selectedClaimTypes') ? 'Please select claim types to proceed' :'' }}
                </span>
              </v-col>
            </v-row>
          </v-container>
        </form>

        <v-card-actions v-if="open && !loading">
          <v-spacer />
          <v-btn
            :disabled="downloadProgressing"
            text
            class="px-10"
            @click="open = false;$emit('close')"
          >
            Close
          </v-btn>
          <v-btn
            :loading="downloadProgressing"
            color="hrissecondary"    
            class="white--text px-10"           
            @click="submitForm"
          >
            Download
          </v-btn>
        </v-card-actions> 
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      open: {
        type: Boolean,
        required: true,
      },
      claimTypes: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        downloadProgressing: false,
        isMerged: 0,
        isGroupByClaimType: 0, // 0 = reference no, 1 = claim type
        selectedClaimTypes: [],
        headers: [
          {
            text: 'Claim Type',
            align: 'left',
            value: 'name',
            sortable: false,
          },
        ],
      }
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.$emit('download')
          })
      },
      prepareFormData () {
        return {
          is_merged: this.isMerged,
          is_group_by_claim_type: this.isGroupByClaimType,
          claim_type_ids: this.selectedClaimTypes.map(type => type.id),
        }
      },
      setProgressing (status) {
        this.downloadProgressing = status
      },
    },
  }
</script>
